import script from "./CounselingRoomGuidanceComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CounselingRoomGuidanceComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__